import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LogoImg from 'assets/logos/logo.png';
import backIcon from 'assets/icons/back.svg';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { ROUTE_PATH } from 'routes';
import useBack from 'hooks/useBack';

const Header = (props) => {
  const {
    title,
    rightMenu = true,
    openRightMenu = false,
    onBack = null,
    onRightMenu = null,
  } = props;

  // Back unificado: maneja el botón in-app y el back nativo (window.backPressed).
  const goBack = useBack(onBack, { listenNative: true });

  const handleClickBack = () => {
    if (openRightMenu) {
      onRightMenu();
    }
    goBack();
  };

  const renderBackButton = () => {
    if (!onBack) {
      return <div className='actions-left' />;
    }
    return (
      <div className='actions-left' onClick={handleClickBack}>
        <img src={backIcon} alt='back-icon' />
      </div>
    );
  };

  const renderLogo = () => {
    if (!title) {
      return (
        <Navbar.Brand>
          <Link to={ROUTE_PATH.HOME}>
            <img src={LogoImg} className='inline-block align-top main-logo' alt='Platform logo' />
          </Link>
        </Navbar.Brand>
      );
    }
    return (
      <Navbar.Text className='header-title'>
        <h3 className='mb-0'>{title}</h3>
      </Navbar.Text>
    );
  };

  const renderActions = () => {
    return (
      // Hamburger is hidden on desktop (lg+); desktop nav is handled by Layout
      <div className='actions-right lg:hidden' onClick={onRightMenu}>
        {rightMenu && (
          <div className={`menu-icon ${openRightMenu ? 'active' : ''}`}>
            <span className='bar' />
            <span className='bar' />
            <span className='bar' />
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {/* header-wrapper height: mobile/tablet=66px, desktop=72px (via lg:h-18) */}
      <Navbar expand='lg' className='header-wrapper lg:hidden lg:!h-[72px]'>
        <Container>
          {renderBackButton()}
          {renderLogo()}
          {renderActions()}
        </Container>
      </Navbar>
      {/* <div className='header-space' /> */}
    </>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  rightMenu: PropTypes.bool,
  openRightMenu: PropTypes.bool,
  onBack: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onRightMenu: PropTypes.func,
};

export default Header;
